<div class="row">
  <div class="col-12">
    <div class="form-group">
      <input placeSearch
             autocomplete="off"
             fullWidth
             nbInput
             [disabled]="form.disabled"
             (placeSelected)="placeChange($event)"
             type="text">
      <slnk-shared-input-validator [pvVibrate]="addressErrorVibrate">
        <slnk-shared-input-validator-item
          [validationFormControl]="form">
        </slnk-shared-input-validator-item>
      </slnk-shared-input-validator>
    </div>
    <pv-google-map
      [center]="{lat: latitude, lng: longitude}"
      [zoom]="zoom"
      [markers]="markers"
      (markerDragEnd)="markerPositionChanged($event)">
    </pv-google-map>
  </div>
</div>
